import { render } from "./ArticlesModal.vue?vue&type=template&id=0b9b9fea"
import script from "./ArticlesModal.vue?vue&type=script&lang=js"
export * from "./ArticlesModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__